var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPacking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 115,
    rx: 25,
    fill: "#3CBD96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.625 68.6667V46.3334C82.624 45.3543 82.3655 44.3926 81.8755 43.545C81.3856 42.6973 80.6813 41.9934 79.8333 41.5038L60.2917 30.3371C59.4429 29.8471 58.4801 29.5891 57.5 29.5891C56.5199 29.5891 55.5571 29.8471 54.7083 30.3371L35.1667 41.5038C34.3187 41.9934 33.6144 42.6973 33.1245 43.545C32.6345 44.3926 32.376 45.3543 32.375 46.3334V68.6667C32.376 69.6458 32.6345 70.6075 33.1245 71.4551C33.6144 72.3028 34.3187 73.0067 35.1667 73.4963L54.7083 84.663C55.5571 85.153 56.5199 85.411 57.5 85.411C58.4801 85.411 59.4429 85.153 60.2917 84.663L79.8333 73.4963C80.6813 73.0067 81.3856 72.3028 81.8755 71.4551C82.3655 70.6075 82.624 69.6458 82.625 68.6667Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1288 43.4301L57.5 57.528L81.8712 43.4301",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 85.64V57.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacking);
export default __webpack_public_path__ + "static/media/packing.b2d2c1cec18e75c43f1c4d7be95390d5.svg";
export { ForwardRef as ReactComponent };